export default "__VITE_ASSET__BOFIuiS4__"